/*
  KB Holzbrett-Menü (Julien 2026-10-04) — Verhalten zum Markup aus
  snippets/header-dropdown-menu.liquid, Optik in kb-menu-board.css.

  Das Brett steht unter dem geöffneten Menüpunkt (--kb-board-x), die Spitze
  oben zeigt genau auf ihn (--kb-notch-x). Beides wird bei jedem Öffnen neu
  gemessen.
*/
(function () {
  function setup(menu) {
    var details = menu.querySelector('details');
    var summary = details && details.querySelector('summary');
    var board = details && details.querySelector('[data-kb-board]');
    if (!board) return;

    details.addEventListener('toggle', function () {
      if (!details.open) return;
      var s = summary.getBoundingClientRect();
      var box = board.offsetParent;
      if (!box) return;
      var c = box.getBoundingClientRect();
      var mitte = s.left + s.width / 2 - c.left;
      var w = board.offsetWidth;
      // 2026-10 (Julien: „Dropdown ist immer mittig, nicht dort wo man
      // drüberhovert"): Das kompakte Brett zentriert sich unter dem Menüpunkt
      // und bleibt dabei innerhalb der Leiste.
      // Grenzen = die Menüzeile selbst (äußerste Menüpunkte), nicht der ganze
      // Header — sonst ragte das Brett links weit über das Menü hinaus.
      var rand = 16;
      var minL = rand;
      var maxR = c.width - rand;
      var punkte = box.querySelectorAll('.header__inline-menu .list-menu--inline > li');
      if (punkte.length) {
        var l0 = Infinity;
        var r0 = -Infinity;
        punkte.forEach(function (li) {
          var r = li.getBoundingClientRect();
          l0 = Math.min(l0, r.left - c.left);
          r0 = Math.max(r0, r.right - c.left);
        });
        if (r0 - l0 >= w) {
          minL = Math.max(minL, l0);
          maxR = Math.min(maxR, r0);
        }
      }
      var links = Math.max(minL, Math.min(mitte - w / 2, maxR - w));
      board.style.setProperty('--kb-board-x', Math.round(links) + 'px');
      var spitze = Math.max(32, Math.min(mitte - links, w - 32));
      board.style.setProperty('--kb-notch-x', Math.round(spitze) + 'px');
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
